import React from "react";
import { DMModal, DMModalTitle, DMModalContent } from "../../../shared/DMModal";

const AssignmentFullViewModal: React.FC<{
  open: boolean;
  onClose: () => void;
  assignment: Record<string, unknown> | null;
  eventDate?: Date;
  children?: React.ReactNode;
  width?: string; // e.g. "50vw", "75vw"
  height?: string; // e.g. "75vh"
}> = ({
  open,
  onClose,
  assignment,
  eventDate,
  children,
  width = "50vw",
  height = "75vh",
}) => (
  <DMModal
    visible={open}
    onClose={onClose}
    closeable
    className=""
    style={{
      width: width,
      maxWidth: width,
      height: height,
      maxHeight: height,
    }}
  >
    <DMModalTitle>
      Assignment State
      {eventDate && (
        <span className="mt-1 block text-xs font-normal text-gray-500">
          {eventDate.toLocaleString()}
        </span>
      )}
    </DMModalTitle>
    <DMModalContent className="flex min-h-0 min-w-0 flex-1 flex-col">
      {children ? (
        children
      ) : (
        <pre className="min-h-0 w-full min-w-0 flex-1 overflow-auto rounded bg-gray-100 p-4 text-xs">
          {assignment ? JSON.stringify(assignment, null, 2) : ""}
        </pre>
      )}
    </DMModalContent>
  </DMModal>
);

export default AssignmentFullViewModal;
